// extracted by mini-css-extract-plugin
export var label = "_cg-2";
export var slideContainer = "_cg-0";
export var slider = "_cg-1";